import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Page } from '../shared/models/pages/page';
import { PagesService } from '../shared/services/pages.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  page: Page = null;

  constructor(
    private _pagesService: PagesService,
    private _sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this._pagesService.getData({slug: 'home'}).subscribe(
      response => this.page = new Page(response),
      error => {
        console.log(error);
        this.page = new Page({});
      }
    );
  }

  public get content(): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(this.page.content.rendered);
  }
}
